/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ServiceFeeType = {
    DEVOURGO_SERVICE: 'DEVOURGO_SERVICE',
    PROMO_SERVICE_REDUCTION: 'PROMO_SERVICE_REDUCTION'
} as const;
export type ServiceFeeType = typeof ServiceFeeType[keyof typeof ServiceFeeType];


export function instanceOfServiceFeeType(value: any): boolean {
    for (const key in ServiceFeeType) {
        if (Object.prototype.hasOwnProperty.call(ServiceFeeType, key)) {
            if (ServiceFeeType[key as keyof typeof ServiceFeeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ServiceFeeTypeFromJSON(json: any): ServiceFeeType {
    return ServiceFeeTypeFromJSONTyped(json, false);
}

export function ServiceFeeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceFeeType {
    return json as ServiceFeeType;
}

export function ServiceFeeTypeToJSON(value?: ServiceFeeType | null): any {
    return value as any;
}

export function ServiceFeeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ServiceFeeType {
    return value as ServiceFeeType;
}

